import { render, staticRenderFns } from "./TrashGroupHistorical.vue?vue&type=template&id=b4caee72&scoped=true&"
import script from "./TrashGroupHistorical.vue?vue&type=script&lang=js&"
export * from "./TrashGroupHistorical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4caee72",
  null
  
)

export default component.exports